import {TranslationsManager} from "../utils/localisationManager";

export function doStyleFooter() {
    $("#signature").append(` | <a href="https://www.fv-studio.cz/?utm_source=utopy&utm_medium=footer+signature" target="_blank" class="footer-customized">${TranslationsManager.doGetStringByLang('FOOTER_EDIT_FV_STUDIO')} <strong>FV STUDIO</strong></a>`);

    $(`
        <div class="bold-contact">
            <h4>${TranslationsManager.doGetStringByLang('FOOTER_FOR_CUSTOMERS')}</h4>
            <ul class="cont"></ul>
        </div>
    `).insertBefore($('#footer .custom-footer .contact-box').parent());

    $('#footer .contact-box ul li > span.tel').parent().clone().appendTo('#footer .bold-contact .cont');
    $('#footer .contact-box ul li > span.mail').parent().clone().appendTo('#footer .bold-contact .cont');
    $('.banner-wrapper .kontakt-banner').find('li').prependTo('#footer .custom-footer .contact-box ul');

    const instaLink = $('#footer .custom-footer .instagram a').attr('href');
    const fbLink = $('#footer .custom-footer .facebook a').attr('href');

    $(`
        <div class="social">
            <div><a class="instagram" href="${instaLink}" target="_blank"></a><a class="facebook" href="${fbLink}" target="_blank"></a></div>
            <ul>
                <li><a href="${TranslationsManager.doGetStringByLang('FOOTER_LINK_PHYLOSOPHY_URL')}">${TranslationsManager.doGetStringByLang('FOOTER_LINK_PHYLOSOPHY')}</a></li>
                <li><a href="${TranslationsManager.doGetStringByLang('FOOTER_LINK_PRIVACY_SAFETY_URL')}">${TranslationsManager.doGetStringByLang('FOOTER_LINK_PRIVACY_SAFETY')}</a></li>
                <li><a href="${TranslationsManager.doGetStringByLang('FOOTER_LINK_COOKIES_URL')}">${TranslationsManager.doGetStringByLang('FOOTER_LINK_COOKIES')}</a></li>
            </ul>
        </div>
    `).appendTo('#footer .custom-footer');

    $('.banner-wrapper img[alt="recenze"]').closest('.banner').parent().addClass('hidden');
    $('.banner-wrapper img[alt="vyhoda"]').closest('.banner').parent().addClass('hidden');
    $('.banner-wrapper .kontakt-banner').closest('.banner').parent().addClass('hidden');


    doStyleNewsletter();
}

function doStyleNewsletter() {
    $('.newsletter-header span').text(`${TranslationsManager.doGetStringByLang('NEWSLETTER_REGISTER')}`);
    $('#footer .custom-footer .extended form button').text(`${TranslationsManager.doGetStringByLang('LOGIN_BTN')}`);
    $(`<p>${TranslationsManager.doGetStringByLang('NEWSLETTER_MSG')}</p>`).insertAfter('.newsletter-header');
}
